<template>
  <div class="table-responsive static-table-list">
    <table class="table table-striped table-hover table-sm" width="100%">
      <thead>
        <tr>
          <th width="40%">{{propertyTitle}}</th>
          <th>{{valueTitle}}</th>
        </tr>
      </thead>
      <tbody>
        <slot />
      </tbody>
    </table>
  </div>
</template>


<script>
export default {
  name: 'PropertyValueTable',
  props: {
    propertyTitle: {
      type: String,
      default: 'Property'
    },
    valueTitle: {
      type: String,
      default: 'Value'
    }
  }
}
</script>